const DEFAULT_ALLOWED_TOKEN_ORIGINS = [
  'http://localhost:8080',
  'http://localhost:8081',
  'https://www.bingo408.cn',
  'https://bingo408.cn',
  'http://bingo408.cn:8085',
  'https://bingo408.cn:8085'
];

const DEFAULT_BRIDGE_REDIRECT_PATH = '/home';

export function isAllowedTokenOrigin(origin) {
  return DEFAULT_ALLOWED_TOKEN_ORIGINS.includes(origin);
}

export function isTokenTransferPayload(payload) {
  return payload?.type === 'TOKEN_TRANSFER' && typeof payload?.token === 'string' && payload.token.length > 0;
}

export function persistTransferredToken(token) {
  if (!token) {
    return false;
  }

  localStorage.setItem('authToken', token);
  localStorage.removeItem('lastTokenValidation');
  return true;
}

export function persistTransferData(transferData) {
  if (!transferData || typeof transferData !== 'object') {
    return;
  }

  Object.entries(transferData).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      localStorage.setItem(key, String(value));
    }
  });
}

export function applyTransferredAuth(payload) {
  if (!isTokenTransferPayload(payload)) {
    return false;
  }

  persistTransferredToken(payload.token);
  persistTransferData(payload.transferData);
  return true;
}

export function resolveBridgeRedirectPath(redirect, fallbackPath = DEFAULT_BRIDGE_REDIRECT_PATH) {
  if (typeof redirect === 'string' && redirect.startsWith('/')) {
    return redirect;
  }

  return fallbackPath;
}

export { DEFAULT_ALLOWED_TOKEN_ORIGINS, DEFAULT_BRIDGE_REDIRECT_PATH };
